export type Rgb = [number, number, number]

export function parseHex(value: string): Rgb | null {
  const match = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(value.trim())
  return match ? [parseInt(match[1], 16), parseInt(match[2], 16), parseInt(match[3], 16)] : null
}

export function toHex(rgb: Rgb): string {
  return `#${rgb.map(channel => Math.round(Math.min(255, Math.max(0, channel))).toString(16).padStart(2, "0")).join("")}`
}

export function mix(rgb: Rgb, target: Rgb, amount: number): Rgb {
  return [0, 1, 2].map(index => rgb[index] + (target[index] - rgb[index]) * amount) as Rgb
}

function luminance(rgb: Rgb): number {
  const [red, green, blue] = rgb.map(channel => {
    const value = channel / 255
    return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4
  })
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue
}

export function contrast(first: Rgb, second: Rgb): number {
  const [light, dark] = [luminance(first), luminance(second)].sort((a, b) => b - a)
  return Math.round(((light + 0.05) / (dark + 0.05)) * 100) / 100
}
